import { Button } from '..'
import { CloseIcon } from '../toast-notification/icons'

export interface SimpleModalProps {
    children: React.ReactChild
    title: any
    buttons: { label: string; onClick: (e: any) => void }[]
    hideFooter?: boolean
    onClose?: () => void
}
export function SimpleModal({
    children,
    title,
    buttons,
    hideFooter = false,
    onClose = () => {},
}: SimpleModalProps) {
    return (
        <div
            onClick={event => event.stopPropagation()}
            className='grid pointer-events-auto'
            style={{
                gridTemplateRows: `90px 1fr ${hideFooter ? '' : '120px'}`,
                width: 600,
            }}>
            <div className='flex flex-row items-center justify-between p-8 border-b border-gray2'>
                <h2 className='mb-0'>{title}</h2>{' '}
                <div
                    className='mb-0 text-2xl cursor-pointer'
                    onClick={() => onClose()}>
                    <CloseIcon />
                </div>
            </div>
            <div className='p-8 '>{children}</div>
            {!hideFooter && (
                <div className='flex flex-row items-center justify-end p-4 bg-gray5'>
                    {buttons.map(button => {
                        return (
                            <Button
                                minimal
                                onClick={button.onClick}
                                className='bg-white border border-black '>
                                {button.label}
                            </Button>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
